export enum ProjectTemplateErrorMessages {
  TEMPLATE_DUPLICATE_FOUND = 'GMA WB Template name already exists. Please enter a different GMA WB Template name.',
  TEMPLATE_NAME_BLANK = 'Template Name text field is blank. Please enter a unique GMA WB Template name then try to save as draft or publish again.',
  TEMPLATE_NAME_CONTAINS_INVALID_CHARS = `GMAWB Template Name cannot contain the following characters: / : * ? " < > |. Please enter a different GMAWB Template Name.`,
}
